<template>
  <button
    @click="clickBtn"
    class="basicbutton complete"
    :class="[fontcolor, bgcolor, border, boxshadow, boxsize]"
    :disabled="disabled"
  >
    <slot name="before-icon"></slot>
    <slot name="btnname"></slot>
    <slot name="after-icon"></slot>
  </button>
</template>
<script>
import BasicButton from './BasicButton.vue';

export default {
  extends: BasicButton
};
</script>
<style scoped src="@/assets/css/basicbutton/basicbutton.css"></style>
